import 'isomorphic-fetch'

export default class LockedTickets {
  constructor(onTicketsAdded) {
    this.el = $('.locked-template')
    this.currentEvent = window.currentEvent
    this.onTicketsAdded = onTicketsAdded

    if (!this.el.length) {
      return false
    }

    this.onExecuted = this.onExecuted.bind(this)

    this.lockedTickets = []
    this.init()
  }

  init() {
    const context = this
    this.el.each(function() {
      const lt = new LockedTicket(
        $(this),
        context.currentEvent,
        context.onExecuted
      )
      context.lockedTickets.push(lt)
    })
  }

  onExecuted(sender, result) {
    const idx = this.lockedTickets.indexOf(sender)
    if (idx > -1) {
      if (result.ok) {
        // Success, let TicketOptions know
        this.lockedTickets.splice(idx, 1)
        this.onTicketsAdded(result.target)
      } else {
        // Failed. Re-bind handlers to new markup
        const lt = new LockedTicket(
          $(result.target),
          this.currentEvent,
          this.onExecuted
        )
        this.lockedTickets[idx] = lt
      }
    }
  }

  getLength() {
    return this.el.length
  }
}

function unlock(eventId, isSeason, templateId, code, target) {
  const path = '/Tickets/Unlock/' + eventId
  const query =
    '?isSeason=' + isSeason + '&template=' + templateId + '&code=' + code

  const onError = err => {
    const e = '<div class="alert alert-error">error</div>'
    console.error(err)
    $(target).prepend(e)
    throw err
  }

  $(target).hide()

  return fetch(path + query, { credentials: 'same-origin' }).then(response => {
    $(target).show()
    return response.text().then(text => {
      const par = target.parent()
      par.html(text)
      return { target: par.children(), ok: response.ok }
    }, onError)
  }, onError)
}

class LockedTicket {
  constructor(el, event, onUnlockAttempted) {
    this.el = el
    this.event = event
    this.onUnlockAttempted = onUnlockAttempted

    this.input = this.el.find('input.template-code')
    this.btn = this.el.find('.unlock-btn')

    this.init()
  }

  init() {
    this.input.keyup(e => {
      if (e.keyCode === 13) {
        this.btn.click()
      }
    })

    this.btn.click(() => {
      const code = this.getCode()

      if (code) {
        const templId = this.getTemplateId()
        const evId = this.getEventId()
        const isSeason = this.getIsSeason()

        unlock(evId, isSeason, templId, code, this.el).then(result => {
          this.onUnlockAttempted(this, result)
        })
      }
    })
  }

  getEventId() {
    return +this.event.id
  }

  getIsSeason() {
    return this.event.isSeason
  }

  getTemplateId() {
    return +this.el.data('template')
  }

  getCode() {
    return this.input.val()
  }
}
